import { IconProductInstantBooking16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ReplyTemplateButton.css';

type TProps = {
  isNewEnabled: boolean;
  onClick: () => void;
};

export const ReplyTemplateButton: React.FC<TProps> = ({ isNewEnabled, onClick }) => {
  return (
    <button onClick={onClick} className={styles['container']}>
      <IconProductInstantBooking16 />
      {isNewEnabled && <span className={styles['new-badge']} data-name="ReplyTemplateButtonNew" />}
    </button>
  );
};
